/**
 * Storlyn 品牌 - Tags 页面配置
 */
import { tagsCommonConfig } from './common'
import type { TagsPageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

export const tagsConfig = {
  ...tagsCommonConfig,
  theme: {
    popupTagBgColor: '#FCECF3',
    popupTagColor: brandTheme.textSecondary,
    filterBgColor: '#FCECF3',
    filterActiveBgColor: brandTheme.primaryColor,
    filterColor: brandTheme.textSecondary,
    filterActiveColor: brandTheme.textInverse,
  },
} satisfies TagsPageConfig
